import { useEffect, useState } from "react";
import { getTokenData, isAuthenticated } from "security";

export interface UserData {
  email: string;
  role: UserRole;
  isAuthenticated: boolean;
  permissions: string[];
}

export enum UserRole {
  ADMINISTRADOR = "Administrador",
  SUPERVISOR = "Supervisor",
  OPERADOR = "Operador",
  AUDITOR_FISCAL = "Auditor fiscal",
}

export function getUserRole(userRole: string): UserRole {
  const roleMap: Record<string, UserRole> = {
    ADMINISTRATOR: UserRole.ADMINISTRADOR,
    SUPERVISOR: UserRole.SUPERVISOR,
    OPERATOR: UserRole.OPERADOR,
  };

  return roleMap[userRole] || UserRole.AUDITOR_FISCAL;
}

const useLoggedUser = (): UserData => {
  const [userInfo, setUserInfo] = useState<UserData>({
    email: "",
    role: UserRole.AUDITOR_FISCAL,
    isAuthenticated: false,
    permissions: [],
  });

  useEffect(() => {
    const fetchUserInfo = () => {
      try {
        const authenticated = isAuthenticated();

        if (!authenticated) {
          setUserInfo({
            email: "",
            role: getUserRole(""),
            isAuthenticated: false,
            permissions: [],
          });
          return;
        }

        const tokenData = getTokenData() as {
          userEmail: string;
          userRole: string;
          permissions: string[];
        };

        setUserInfo({
          email: tokenData.userEmail || "",
          role: getUserRole(tokenData.userRole || ""),
          isAuthenticated: true,
          permissions: tokenData.permissions,
        });
      } catch (error) {
        console.error("Error getting user info:", error);
        setUserInfo({
          email: "",
          role: getUserRole(""),
          isAuthenticated: false,
          permissions: [],
        });
      }
    };

    fetchUserInfo();
  }, []);

  return userInfo;
};

export default useLoggedUser;
